import { Outlet } from 'react-router-dom';
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { ProveedorSidebar } from '@/modules/proveedor/Sidebar';
import { ProveedorSiteHeader } from '@/modules/proveedor/SiteHeader';
import { useProveedorPageTitle } from '@/modules/proveedor/usePageTitle';

export default function ProveedorLayout() {
  const title = useProveedorPageTitle();

  return (
    <SidebarProvider>
      <ProveedorSidebar variant="inset" />
      <SidebarInset className="flex flex-col min-h-dvh overflow-hidden">
        <ProveedorSiteHeader title={title} />
        <div className="flex-1 min-h-0 flex flex-col bg-background overflow-auto overflow-x-hidden">
          <Outlet />
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
